import { render } from "./ProductsMenu.vue?vue&type=template&id=69dfe880&scoped=true"
import script from "./ProductsMenu.vue?vue&type=script&lang=js"
export * from "./ProductsMenu.vue?vue&type=script&lang=js"

import "./ProductsMenu.vue?vue&type=style&index=0&id=69dfe880&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dfe880"]])

export default __exports__